import { render, staticRenderFns } from "./DeleteNationalEventDialog.vue?vue&type=template&id=0bf2d7ec&"
import script from "./DeleteNationalEventDialog.vue?vue&type=script&lang=ts&"
export * from "./DeleteNationalEventDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports